export const translateVector = (data, translator) => {
  const translated = [];
  var objTranslated = {};

  if (data != undefined) {
    if (data.length > 0) {
      for (let element of data) {
        translated.push(translator(element));
      }
      return translated;
    } else {
      objTranslated = translator(data);
      return objTranslated;
    }
  }
};

export default translateVector;
